// Decisions about what Focus shows while its data is incomplete or failing.

/**
 * A failed load only replaces the queue when there is no queue to keep. React
 * Query keeps the last data when a background refetch fails, so a seller with
 * leads on screen keeps working through a burst of 503s.
 */
export function isBlockingError(error: unknown, cachedLeads: number): boolean {
  return !!error && cachedLeads === 0
}

/**
 * Whether a jump in flight should hold the selection while the lead is missing
 * from the visible list. Only while the lead is in the loaded book: a jump to a
 * lead the response does not contain would otherwise leave nothing selected,
 * and Focus would show its done screen over a full queue.
 */
export function holdsPendingJump(
  pendingId: string | null,
  selectedId: string | null,
  leads: readonly { id: string }[],
): boolean {
  return !!pendingId && pendingId === selectedId && leads.some(l => l.id === pendingId)
}
